import { ReactNode } from "react";
import { FaXTwitter, FaLinkedin, FaInstagram, FaYoutube, FaGithub } from "react-icons/fa6";

export interface FooterSection {
  title: string;
  items: string[];
}

export interface FooterLink {
  title: string;
  href: string;
}

export interface SocialLink {
  title: string;
  href: string;
  icon: ReactNode;
}

export interface FooterData {
  sections: FooterSection[];
  ratlfooterlinks: FooterLink[];
  items: FooterLink[];
  socials: SocialLink[];
}

export const footerData: FooterData = {
  sections: [
    {
      title: "Product",
      items: [
        "Features",
        "Security",
        "Team",
        "Enterprise",
        "Customer stories",
        "The ReadME Project",
        "Pricing",
        "Resources",
        "Roadmap",
        "Compare GitHub",
      ],
    },
    {
      title: "Platform",
      items: ["Developer API", "Partners", "Electron", "GitHub Desktop"],
    },
    {
      title: "Support",
      items: [
        "Docs",
        "Community Forum",
        "Professional Services",
        "Premium Support",
        "Skills",
        "Status",
        "Contact GitHub",
      ],
    },
    {
      title: "Company",
      items: [
        "About",
        "Blog",
        "Careers",
        "Press",
        "Inclusion",
        "Social Impact",
        "Shop",
      ],
    },
  ],
  ratlfooterlinks: [
    { title: "About Us", href: "/about-us" },
    { title: "Pricing", href: "/pricing" },
    { title: "Blog", href: "/blog" },
    { title: "Contact Us", href: "/contact-us" },
  ],
  items: [
    { title: "Terms of Use", href: "/terms-of-use" },
    { title: "Privacy Policy", href: "/privacy-policy" },
  ],
  socials: [
    {
      title: "Twitter",
      icon: <FaXTwitter color="#656565" size={24} />,
      href: "https://x.com/ratlaitech",
    },
    {
      title: "LinkedIn",
      icon: <FaLinkedin color="#656565" size={24} />,
      href: "https://www.linkedin.com/company/ratlai/",
    },
    {
      title: "Instagram",
      icon: <FaInstagram color="#656565" size={24} />,
      href: "https://www.instagram.com/ratlaitech/",
    },
    {
      title: "YouTube",
      icon: <FaYoutube color="#656565" size={24} />,
      href: "https://www.youtube.com/@ratlaitech",
    },
    {
      title: "GitHub",
      icon: <FaGithub color="#656565" size={24} />,
      href: "https://github.com/ratlai",
    },
  ],
};
